export const EVENT_STORE_LOCATOR_SELECT_STORE = 'store_selector_select';
